<template id="list-item">
  <td
    v-if="column.visible"
    :class="[columnCellClass, (isEditableFunction || isEditableBoolean)?'column-editable':'column-not-editable', 'md-table-cell']"
    :style="{ width: column.width, 'font-size': fontSize }"
  >
    <div class="md-table-cell-container">
      <div class="datatable-tooltip" v-if="allowTooltips && row && row[column.name] && row[column.name] != '' && column.customTooltip !== false">
        <template v-if="column.customTooltip && typeof(column.customTooltip) === 'function'">{{column.customTooltip(row)}}</template>
        <template v-else-if="column.customTooltip && typeof(column.customTooltip) === 'string'">{{column.customTooltip}}</template>
        <template v-else>{{row[column.name]}}</template>
      </div>
      <div v-if="column.visible && column.slotName" :class="`table-cell-slot-${column.slotName}`">
        <slot>Where is your slot content?</slot>
      </div>
      <div style="width:100%;" v-else-if="isSimpleCell && !isEditableFunction && !isEditableBoolean">
        <div>
          {{row[column.name]}}
        </div>
      </div>
      <div v-else-if="isSimpleCell && (isEditableFunction || isEditableBoolean)" style="width:100%;">
        <div>
          <div v-if="column.type === 'textarea'">
              <textarea v-model="row[column.name]"
                        :disabled="!isEditableFunction && !isEditableBoolean"
                        :name="column.name+row.id"
                        @blur="$emit('setRowBlur', row, column)"
                        @focus="$emit('setFocus', row, column)"
                        @change="$emit('setRowChanged', row, column)"
              ></textarea>
          </div>
          <div v-else-if="column.type === 'checkbox'">
            <div class="md-input-container md-theme-default">
              <div class="md-checkbox md-theme-default" :class="{'md-checked': row[column.name]}" @click="$refs[column.name+row.id].click()">
                <div tabindex="0" class="md-checkbox-container">
                  <input type="checkbox" :name="column.name+row.id" :ref="column.name+row.id" tabindex="-1" v-model="row[column.name]" @change="$emit('setRowChanged', row, column)">
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="inputType === 'text'">
            <div class="md-input-container md-theme-default md-has-value">
              <input
                type="text"
                :name="column.name+row.id"
                class="md-input" v-model="row[column.name]"
                :disabled="!isEditableFunction && !isEditableBoolean"
                @blur="$emit('setRowBlur', row, column)"
                @focus="$emit('setFocus', row, column)"
                @change="$emit('setRowChanged', row, column)"
              />
            </div>
          </div>
          <div v-else-if="inputType === 'number'">
            <div class="md-input-container md-theme-default">
              <input
                v-if="typeof column.min !== 'undefined' || typeof column.max !== 'undefined'"
                type="number"
                :name="column.name+row.id"
                class="md-input" v-model="row[column.name]"
                :disabled="!isEditableFunction && !isEditableBoolean"
                @blur="$emit('setRowBlur', row, column)"
                @focus="$emit('setFocus', row, column)"
                @change="$emit('setRowChanged', row, column)"
                :min="(typeof column.min == 'function') ? column.min(row) : column.min"
                :max="(typeof column.max == 'function') ? column.max(row) : column.max"
                oninput="validity.valid||(value='');"
              />
              <input
                v-else
                type="number"
                :name="column.name+row.id"
                class="md-input" v-model="row[column.name]"
                :disabled="!isEditableFunction && !isEditableBoolean"
                @blur="$emit('setRowBlur', row, column)"
                @focus="$emit('setFocus', row, column)"
                @change="$emit('setRowChanged', row, column)"
              />
            </div>
          </div>
          <div v-else-if="inputType === 'checkbox'">
            <div class="md-input-container md-theme-default">
              <input
                type="checkbox"
                :name="column.name+row.id"
                class="md-input" v-model="row[column.name]"
                :disabled="!isEditableFunction && !isEditableBoolean"
                @blur="$emit('setRowBlur', row, column)"
                @focus="$emit('setFocus', row, column)"
                @change="$emit('setRowChanged', row, column)"
              />
            </div>
          </div>
          <div v-else-if="inputType === 'password'">
            <div class="md-input-container md-theme-default">
              <input
                type="password"
                :name="column.name+row.id"
                class="md-input" v-model="row[column.name]"
                :disabled="!isEditableFunction && !isEditableBoolean"
                @blur="$emit('setRowBlur', row, column)"
                @focus="$emit('setFocus', row, column)"
                @change="$emit('setRowChanged', row, column)"
              />
            </div>
          </div>
        </div>
        <span class="wb-tooltip" v-if="row[column.tooltip]">{{row[column.tooltip]}}</span>
      </div>
      
      <div v-else-if="column.visible && column.type !== 'boolean' && column.type !== 'autocomplete' && (column.type === 'dateWithTime' || column.type === 'dateFromTo') && !column.cellTemplate && !column.isObjectSelection && !column.isButtonColumn && !column.isObjectMultiSelection"
           style="width:100%;">
        <div>
          <div v-if="column.type === 'dateWithTime'">
            <date-picker-wrapper
              :row="row"
              :disabled="!isEditableFunction && !isEditableBoolean"
              v-model="row[column.name]"
              @blur.native="$emit('setRowBlur', row, column)"
              @change="$emit('setRowChanged', row, column, true)"
              :placeholder="dataTimePlaceholder"
              :datepickerOptions="column.datepickerOptions"
              :format="column.format"
              :limit="column.limit"
              ref="datePickerWrapper"
              class="datepicker-custom-wrapper"
            ></date-picker-wrapper>
          </div>
        </div>
        <span class="wb-tooltip" v-if="row[column.tooltip]">{{row[column.tooltip]}}</span>
      </div>

      <div v-else-if="column.visible && column.type !== 'boolean' && column.type !== 'autocomplete' && column.type === 'time' && !column.cellTemplate && !column.isObjectSelection && !column.isButtonColumn && !column.isObjectMultiSelection"
           style="width:100%;">
        <div>
          <!-- <vue-timepicker v-model="row[column.name]" :disabled="!isEditableFunction && !isEditableBoolean" v-bind="column.options"></vue-timepicker> -->
          <input
            type="time"
            :name="column.name+row.id"
            class="md-input" v-model="row[column.name]"
            :disabled="!isEditableFunction && !isEditableBoolean"
            @blur="$emit('setRowBlur', row, column)"
            @focus="$emit('setFocus', row, column)"
            @change="$emit('setRowChanged', row, column)"
            :min="(typeof column.min == 'function') ? column.min(row) : column.min"
            :max="(typeof column.max == 'function') ? column.max(row) : column.max"
            oninput="validity.valid||(value='');"
          />
        </div>
        <span class="wb-tooltip" v-if="row[column.tooltip]">{{row[column.tooltip]}}</span>
      </div>

      <div v-else-if="column.visible && column.type !== 'boolean' && column.type === 'autocomplete' && !(column.type === 'dateWithTime' && column.type === 'dateFromTo') && !column.cellTemplate && !column.isObjectSelection && !column.isButtonColumn && !column.isObjectMultiSelection"
           style="width:100%;"
      >
        <div>
          <md-input-container>
            <md-autocomplete
              v-model="row[column.name]"
              @change="$emit('setRowChanged', row, column)"
              @focus="$emit('setFocus', row, column)"
              @selected="$emit('setRowSelect', row, column)"
              :fetch="(q) => column.fetchAutoComplete(q, row, column)"
              print-attribute="name"
              :debounce="100"
              :disabled="!isEditableFunction && !isEditableBoolean"
            />
          </md-input-container>
        </div>
        <span class="wb-tooltip" v-if="row[column.tooltip]">{{row[column.tooltip]}}</span>
      </div>
      <div v-else-if="column.visible && !column.cellTemplate && column.type === 'boolean'"
           @blur.native="$emit('setRowBlur', row, column)"
           @click="$emit('setRowChanged', row, column)">
        <md-switch v-if="isEditableFunction || isEditableBoolean" v-model="row[column.name]"><div v-if="listOfOptionsForSwitch">{{row[column.name] ? listOfOptionsForSwitch[0] : listOfOptionsForSwitch[1]}}</div></md-switch>
        <div v-else>
          <div v-if="listOfOptionsForSwitch && row[column.name]">{{listOfOptionsForSwitch[0]}}</div>
          <div v-else-if="listOfOptionsForSwitch && row[column.name]">{{listOfOptionsForSwitch[1]}}</div>
          <div v-else>{{row[column.name]}}</div>
        </div>
      </div>
      <div v-else-if="column.visible && !column.cellTemplate && column.isObjectSelection">
        <!-- <md-select
          :name="column.name"
          :id="column.name"
          v-model="row[column.name]"
          :disabled="!isEditableFunction && !isEditableBoolean"
          :key="column.name"
          @blur.native="$emit('setRowBlur', row, column)"
        >
          <md-option v-for="element in getObjectList" :value="element.id" :key="element.id"  v-on:selected="$emit('setRowChanged', row, column)">{{element.name}}</md-option>
        </md-select> -->
        <div class="md-select md-theme-default" @click="$emit('showSelectWindow', $event, row, column, getObjectList, !isEditableFunction && !isEditableBoolean)">
          <div class="md-menu">
            <span md-menu-trigger="" class="md-select-value">{{computedSelectValue}}</span>
          </div>
        </div>





      </div>
      <div v-else-if="column.visible && !column.cellTemplate && column.isObjectMultiSelection">
        <md-select
          v-if="typeof row[column.name] !== 'undefined'"
          :name="column.name"
          :id="column.name"
          :disabled="!isEditableFunction && !isEditableBoolean"
          @blur.native="$emit('setRowBlur', row, column)"
          v-model="row[column.name]" multiple>
          <template v-if="getObjectList">
            <md-option v-for="element in getObjectList" v-if="!(element.isHidden && typeof element.isHidden === 'function' && element.isHidden(row))" :key="element.id" :value="element.id" v-on:selected="$emit('setRowChanged', row, column)">{{element.name}}</md-option>
          </template>
        </md-select>
      </div>
      <div v-else-if="column.visible && column.isButtonColumn && !column.cellTemplate">
        <md-button class="md-icon-button" v-on:click.native.stop="column.clickFunction(row)">
          <md-icon>{{column.buttonIcon}}</md-icon>
        </md-button>
      </div>
      <div v-else-if="column.visible && column.cellTemplate"
        v-bind:class="(column.columnClass && typeof column.columnClass === 'function')?column.columnClass(row):''"
        v-html="(column.cellTemplate && typeof column.cellTemplate === 'function')?column.cellTemplate(row):column.cellTemplate" v-on:click.stop="column.onClickRow(row)">
      </div>
    </div>
    <div v-if="adjustableColumnWidth && rowIndex === 0 && columnIndex > 0" :draggable="false" :class="[column.name,'adjustable-column-width-border']" @mousedown="onmousedownAdjustableBorder(row, column, $event)"></div>
  </td>
</template>

<style scoped>

  .adjustable-column-width-border {
    width: 4px;
    height: 100%;
    top: 0;
    position: fixed;
    display: inline-block;
    cursor: col-resize;
    background: rgba(0,0,0,.1);
    z-index: 999;
    user-select: none;
  }
  .adjustable-column-width-border:hover {
    background: #000;
    cursor: col-resize;
  }

  .table-edit-column{
    width: 70px;
  }
  .table-edit-header{
    text-align:left !important;
  }
  .md-input-container{
    margin: 0;
    padding-top: 0;
    min-height: 0;
  }
  .md-button.md-fab .md-icon, .md-button.md-icon-button .md-icon{
    position : inherit;
  }
  .select-container{
    background: #f2f2f2;
    position: absolute;
    right: 10px;
    top: 100px;
    padding: 10px 0;
    z-index: 99;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  }
  .select-container>div{
    overflow: auto;
    max-height: 25vh;
  }
  .select-container>div>div{
    padding-left: 10px;
  }
  .select-container>div>div:hover{
    background: #e1e1e1;
    cursor: pointer;
  }
  .md-theme-default.md-table-card {
    position: initial;
  }
  .md-theme-default.md-table-card .md-toolbar {
    z-index: 3;
  }
  .md-table .md-table-cell .md-table-cell-container>div>div{
    word-wrap: break-word;
    width: 100%;
    padding-right: 4px;
  }
</style>

<script>
  import datePickerWrapper from './datePickerWrapper.vue';
  // import VueTimepicker from 'vuejs-timepicker';

  export default {
    name: 'customTableCell',
    props: [
      'adjustableColumnWidth',
      'rowIndex',
      'row',
      'allowTooltips',
      'fontSize',
      'column',
      'dataList0',
      'dataList1',
      'dataList2',
      'dataList3',
      'objectList',
      'columnCellClass',
      'listOfOptionsForSwitch',
      'isSimpleCell',
      'isEditableBoolean',
      'dataTimePlaceholder',
      'columns',
      'hasSelection',
      'columnIndex'
    ],
    components: {
      datePickerWrapper,
    },
    methods: {
      onmousedownAdjustableBorder(row, column, e) {
        let firstPosition, line, self = this, column1Width, column2Width;
        if (e.target) {
          line = e.target.cloneNode(true);
          line.style.position = 'absolute';
          let visibleColumns = this.columns.filter(i => i.visible);
          let tempIndex = visibleColumns.findIndex(i => i.name === column.name && i.displayName === column.displayName);

          if (!visibleColumns[tempIndex - 1]) return;
          let th = document.querySelector(`.md-table-header .${column.name}`);
          let th1 = document.querySelector(`.md-table-header .${visibleColumns[tempIndex - 1].name}`);
          column1Width = th.offsetWidth;
          column2Width = th1.offsetWidth;
          line.className = line.className + ' temp-line';

          moveAt(e);
          document.querySelector('.adjustable-column-width-table').appendChild(line);
          line.style.zIndex = 1000;

        }
        function moveAt(e) {
          // line.style.top = e.pageY - line.offsetHeight / 2 + 'px';
          const newLeft = e.pageX - line.offsetWidth / 2;
          if (!firstPosition)
            firstPosition = newLeft;

          const diff = firstPosition - newLeft;
          // console.log(diff, column1Width, column2Width) // if > 0 - moving left
          if (diff > (column2Width - 4) || diff < (-1 * column1Width + 2)) return;
          line.style.left = newLeft + 'px';
          self.$emit('ondragAdjustableBorder', row, column, firstPosition, line.style.left, column1Width, column2Width)
        }

        document.onmousemove = (e) => {
          moveAt(e);
        }

        document.onmouseup = () => {
          document.onmousemove = null;
          line.onmouseup = null;
        }
      },
      ondragAdjustableBorder(row, column, event) {

        // this.$emit('ondragAdjustableBorder', row, column, event)
      },
    },
    data() {
      return {
        getObjectList: (this.column.objectList === 'objectList') ? this.objectList[this.column.name] : this[this.column.objectList]
      }
    },
    computed: {
      computedSelectValue () {
        
        if (this.row[this.column.name] && Array.isArray(this.getObjectList)) {
          const value = this.getObjectList.find(i => i.id == this.row[this.column.name]);
          return (value && value.name) ? value.name : '';
        } else if (this.getObjectList && this.row[this.column.name] && this.column.name&& this.getObjectList[this.row[this.column.name]]) {
          const value = this.getObjectList[this.row[this.column.name]];
          return (value && value.name) ? value.name : '';
        }
        return '';
      },
      inputType: function() {
        const type = this.column.type.toLowerCase().trim();
        if (type === 'number') return 'number';
        if (type === 'boolean') return 'checkbox';
        if (type === 'password') return 'password';
        return 'text';
      },
      isEditableFunction: function() {
        return this.column && ((typeof this.column.isEditable === 'function' && this.column.isEditable(this.row)));
      },
    }
  };
</script>



// WEBPACK FOOTER //
// customTableCell.vue?2304c7b4